export default "__VITE_ASSET__CRDYHHv1__"